import * as React from "react";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";

export function LoadingProgress({
    loadingProgressPercent,
}: {
    loadingProgressPercent?: number;
}) {
    if (loadingProgressPercent === undefined) {
        return null;
    }

    const value = loadingProgressPercent === 0 ? null : loadingProgressPercent;

    return (
        <progress
            className={StyleClassAuto({
                maxWidth: "30px",
                position: "absolute",
                top: "13px",
                right: "-8px",
                accentColor: `orange`,
            })}
            value={value as any}
            max="100"
        />
    );
}
